export default "__VITE_ASSET__c302d638__"